import {
  combine,
  withCallbacks,
  withContext,
  withMemo,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import EventsOverviewComponent from './component'
import { createColumns } from './columns.description'

export const EventsOverview = combine({
  hooks: [
    withTableController({ id: 'events-table' }),
    withContext('appStore', StoreContext),

    withCallbacks(
      {
        loadEvents:
          ({ appStore, table }) =>
            async (tableState, _table, query) => {
              // only for current day
              const currentDate = Date.now()

              // Use either the passed query or retrieve stored filter data from the controller
              const filterData = query || table.getFilterData();
              const { search: matchNameSearch, sport: sportType, tournamentId } = filterData || {};

              const { events, response } = await appStore.events.load({
                page: tableState.page,
                size: tableState.pageSize,
                matchNameSearch,
                tournamentId,
                sportType,
                startTimeEqOrGreater: currentDate,
                resolvedStatus: 'NOT_RESOLVED'
              })

              // Filter out any resolved events to ensure they're not displayed
              const filteredEvents = events.filter(event => !event.resolved)

              return {
                ...response,
                content: filteredEvents,
              }
            },

        loadUpcomingTournaments:
          ({ appStore }) =>
            async (tableState, _table, query) => {
              // Use either the passed query or default values
              const filterData = query || {};
              const { sport: sportType } = filterData || {};

              const { tournaments, response } = await appStore.tournaments.loadUpcoming({
                page: tableState.page,
                size: tableState.pageSize,
                sportType,
                upComingEventType: 'ALL',
              })

              return {
                ...response,
                content: tournaments,
              }
            },

        loadAllTournaments:
          ({ appStore }) =>
            async (tableState, _table, query) => {
              // Use either the passed query or default values
              const filterData = query || {};
              const { sport: sportType } = filterData || {};

              const { tournaments, response } = await appStore.tournaments.loadAll({
                page: tableState.page,
                size: tableState.pageSize,
                sportType,
              })

              return {
                ...response,
                content: tournaments,
              }
            },

        onSearch:
          ({ table }) =>
            (query) => {
              table.search(query)
            },

        onInWin:
          ({ appStore, table }) =>
            async ({ beneficiary, trigger, amount }) => {
              await appStore.inwins.create(trigger, beneficiary, amount)
              table.refresh()
            },
      },
      []
    ),
    withMemo('columns', (state) => createColumns(state), []),
  ],
  transformProps: ({ appStore, ...rest }) => {
    return {
      ...rest,
      appConfig: appStore.appConfig,
    }
  },
})(EventsOverviewComponent)
